import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { webColors, webBorderRadius, webShadows } from '../../../../constants/webStyles';
import { COUNTRIES, ENABLED_COUNTRIES } from '../../../../constants/countries';

const StepCountry = ({ formData, updateFormData, goToStep }) => {
  const selectCountry = (code) => {
    updateFormData('country', code);
  };

  return (
    <View style={styles.container}>
      <View style={styles.stepHeader}>
        <Text style={styles.stepIcon}>🌏</Text>
        <Text style={styles.stepTitle}>Select Country</Text>
        <Text style={styles.stepSubtitle}>Choose your country to get started</Text>
      </View>

      <View style={styles.countryList}>
        {ENABLED_COUNTRIES.map((countryCode) => {
          const country = COUNTRIES[countryCode];
          const isSelected = formData.country === countryCode;
          return (
            <TouchableOpacity
              key={countryCode}
              style={[
                styles.countryOption,
                isSelected && styles.countryOptionSelected,
              ]}
              onPress={() => selectCountry(countryCode)}
            >
              <Text style={styles.countryFlag}>{country.flag}</Text>
              <Text style={styles.countryName}>{country.name}</Text>
              <View style={[
                styles.countryCheck,
                isSelected && styles.countryCheckSelected,
              ]}>
                {isSelected && (
                  <Text style={styles.checkmark}>✓</Text>
                )}
              </View>
            </TouchableOpacity>
          );
        })}
      </View>

      <View style={styles.btnRow}>
        <TouchableOpacity
          style={[styles.btnNext, styles.btnSingle, !formData.country && styles.btnNextDisabled]}
          onPress={() => goToStep(2)}
          disabled={!formData.country}
        >
          <Text style={[styles.btnNextText, !formData.country && styles.btnNextTextDisabled]}>
            Next
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  stepHeader: {
    marginBottom: 32,
  },
  stepIcon: {
    fontSize: 48,
    marginBottom: 16,
  },
  stepTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 8,
  },
  stepSubtitle: {
    fontSize: 16,
    color: webColors.primary,
  },
  countryList: {
    gap: 12,
    marginBottom: 32,
  },
  countryOption: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    padding: 18,
    paddingHorizontal: 20,
    backgroundColor: webColors.backgroundAlt,
    borderWidth: 2,
    borderColor: webColors.border,
    borderRadius: webBorderRadius.large,
  },
  countryOptionSelected: {
    borderColor: webColors.primary,
    backgroundColor: webColors.primaryLight,
  },
  countryFlag: {
    fontSize: 28,
  },
  countryName: {
    flex: 1,
    fontSize: 17,
    fontWeight: '600',
    color: webColors.textPrimary,
  },
  countryCheck: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: '#d1d5db',
    alignItems: 'center',
    justifyContent: 'center',
  },
  countryCheckSelected: {
    backgroundColor: webColors.primary,
    borderColor: webColors.primary,
  },
  checkmark: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '700',
  },
  btnRow: {
    flexDirection: 'row',
    gap: 16,
    marginTop: 24,
  },
  btnSingle: {
    flex: 1,
  },
  btnNext: {
    flex: 2,
    backgroundColor: webColors.primary,
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderRadius: webBorderRadius.medium,
    alignItems: 'center',
    ...webShadows.button,
  },
  btnNextDisabled: {
    backgroundColor: webColors.border,
    shadowOpacity: 0,
  },
  btnNextText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
  btnNextTextDisabled: {
    color: webColors.textMuted,
  },
});

export default StepCountry;
